import { Role, RoleDto } from '@app/store/shared/models';
import { ApiResponse } from '@shared/models';

export class Roles {
    items: Role[];
    total: number;

    constructor(response: ApiResponse<RoleDto[]>) {
        this.items = (response.data ?? []).map((dto) => new Role(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
